import './commonAssets';

import '../audioblocks/stylesheets/audioblocks-style-custom.less';
import '../common/stylesheets/modules/collections/collection-browse.less';
import '../common/stylesheets/modules/collections/collection-template.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget.less';


import AppLoader from '../react/AppLoader/AppLoader';
import StockItemCollectionContainer from '../react/app/Search/containers/StockItemCollectionContainer';
import ReactToastifyContainer from '../react/ReactToastify/containers/ReactToastifyContainer';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';
import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import AudioContainer from '../react/Audio/containers/AudioContainer';
import AudioSiteConstants from '../react/common/SiteConstants/AudioSiteConstants';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [
    {
      name: 'Collection',
      path: new AudioSiteConstants().getCollectionsRoute(),
      component: StockItemCollectionContainer,
    },
  ],
  auxApps: {
    ...NavApps,
    'audio-app': AudioContainer,
    'pop-up-container': PopUpsContainer, // FIXME: causes missing matching <div> in <section>
    'nps-modal': NPSModalLoaderContainer,
    'react-toastify-container': ReactToastifyContainer, // FIXME: causes missing matching <div> in <section>
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  },
});
